// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import moment from 'moment';
import t from 'tcomb';

const RegistrationHistory = t.struct({
    customerSummary: CustomerSummary,
    deliveryDate: t.Number,
    endUseCode: KeyValuePair,
    firstUseDate: t.Number,
    id: t.String,
    purchaserType: KeyValuePair,
    registrationDate: t.Number,
    responsibleDealer: Dealer,
    statusIndicator: KeyValuePair
}, {
    name: 'RegistrationHistory',
    strict: true
});

export const getDefaultState = () => new RegistrationHistory({
    customerSummary: getCustomerSummaryDefaultState(),
    deliveryDate: moment().utc().unix(),
    endUseCode: getKeyValueDefaultState(),
    firstUseDate: moment().utc().unix(),
    id: '',
    purchaserType: getKeyValueDefaultState(),
    registrationDate: moment().utc().unix(),
    responsibleDealer: getDealerDefaultState(),
    statusIndicator: getKeyValueDefaultState()
});

export default RegistrationHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/registration-history.js